/**
 * Menu theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/menu.ts
 */
import { menuAnatomy as parts } from '@chakra-ui/anatomy';
import { textStyles } from '../textStyles';
export const Menu = {
    parts: parts.keys,
    baseStyle() {
        return {
            list: {
                bg: 'gradients.dark-blue',
                rounded: '8px',
                borderWidth: '1px',
                borderColor: 'brand.gray-scale-border-10',
                py: '4px',
                boxShadow: 'none',
                zIndex: 2,
            },
            item: {
                ...textStyles.body2Bold,
                px: '16px',
                py: '12px',
                textTransform: 'capitalize',
                bg: 'transparent',
                _hover: {
                    bg: 'whiteAlpha.50',
                },
            },
        };
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
